import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PartnerHealthsService, PartnerHealthState, PartnerHealthSubState } from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, publishReplay, refCount, switchMap, take } from 'rxjs/operators';
import { partnerId } from '../../globals';

@Injectable()
export class FailedPaymentsService {
  partnerSuspended$: Observable<boolean>;

  constructor(private router: Router, private partnerHealthsService: PartnerHealthsService) {
    this.partnerSuspended$ = this.getPartnerSuspended().pipe(publishReplay(1), refCount());
    this.pageChanged$
      .pipe(
        filter((pageChanged) => !!pageChanged),
        switchMap(() => this.partnerSuspended$),
      )
      .subscribe((partnerSuspended) => {
        if (partnerSuspended) {
          this.router.navigateByUrl('/account/restricted');
        }
      });
  }

  getPartnerSuspended(): Observable<boolean> {
    return this.partnerHealthsService.get(partnerId).pipe(
      take(1),
      map((partnerHealth) => {
        return (
          partnerHealth.state === PartnerHealthState.PARTNER_HEALTH_STATE_RESTRICTED &&
          partnerHealth.subState === PartnerHealthSubState.PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED
        );
      }),
      catchError(() => {
        return of(false);
      }),
    );
  }

  get pageChanged$(): Observable<boolean> {
    return this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e: NavigationEnd) => this.urlChecker(e.url)),
    );
  }

  urlChecker(url: string): boolean {
    return !(
      url.startsWith('/account/no-access') ||
      url.indexOf('/account/restricted') > -1 ||
      url.startsWith('/public')
    );
  }
}
